module.exports = __webpack_public_path__ + "fonts/Graphik-BoldItalic.72e39f78.ttf";